import { productWithConciergeMetricsSchema } from "@redotech/redo-model/conversation/rpc/product-with-concierge-metrics";
import * as z from "zod";

export const getConciergeDashboardProductTableData = {
  name: "getConciergeDashboardProductTableData" as const,
  input: z.object({
    dateRange: z.object({ start: z.date(), end: z.date() }),
    pagination: z.object({ token: z.string().optional() }),
    searchText: z.string().optional(),
  }),
  output: z.object({
    productsWithConciergeMetrics: z.array(productWithConciergeMetricsSchema),
    pagination: z.object({ token: z.string().optional() }),
  }),
};
